module.exports = __webpack_public_path__ + "static/media/cloud-upload-logo.e0eab5fa.svg";